import * as actionTypes from "../../actionLabels/index";
const initialState = {
  getAllSellerTaxGen: [],
  getAllSellerTaxGenBuyer: [],
  getAllSellerTaxGenGen: [],
  getAllSellerTaxGenSale: [],
  getAllSellerTaxGenLot: [],
  getAllSellerTaxGenSession: [],
  SellerTaxGenById: [],
  SellerTaxGenAuctionById: [],
  getAllAuctiondata: [],
  ChargeById: [],
  getAllSubmit: [],
  getAllNot: [],
  ApiStatusSeller: false,
  exportData: [],
  loading: false,
  downloading: false
};

const getSellerTaxGenReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_SUCCESS:
      return {
        ...state,
        getAllSellerTaxGen: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_FAIL:
      return {
        ...state,
        getAllSellerTaxGen: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_SUCCESS_BUYER:
      return {
        ...state,
        getAllSellerTaxGenBuyer: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_FAIL_BUYER:
      return {
        ...state,
        getAllSellerTaxGenBuyer: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_GEN_SUCCESS:
      return {
        ...state,
        getAllSellerTaxGenGen: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_GEN_FAIL:
      return {
        ...state,
        getAllSellerTaxGenGen: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_SUCCESS:
      return {
        ...state,
        getAllSellerTaxGenSale: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_FAIL:
      return {
        ...state,
        getAllSellerTaxGenSale: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_LOT_SUCCESS:
      return {
        ...state,
        getAllSellerTaxGenLot: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_LOT_FAIL:
      return {
        ...state,
        getAllSellerTaxGenLot: [],
        error: action.payload,
      };
    case actionTypes.GET_SELLER_TAX_GEN_BY_ID:
      return {
        ...state,
        downloading: true
      }
    case actionTypes.GET_INVOICE_BY_ID_SUCCESS:
      return {
        ...state,
        downloading: false,
        SellerTaxGenById: action.payload,
        error: null,
      };

      case actionTypes.GET_INVOICE_AUCTION_BY_ID_SUCCESS:
      return {
        ...state,
        downloading: false,
        SellerTaxGenAuctionById: action.payload,
        error: null,
      };
      

    case actionTypes.GET_INVOICE_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION_SUCCESS:
      return {
        ...state,
        getAllSellerTaxGenSession: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION_FAIL:
      return {
        ...state,
        getAllSellerTaxGenSession: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_AUCTION_CENTER_INVOICE_SUCCESS:
      return {
        ...state,
        getAllAuctiondata: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_AUCTION_CENTER_INVOICE_FAIL:
      return {
        ...state,
        getAllAuctiondata: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_CHARGE_TAX_SUCCESS:
      return {
        ...state,
        ChargeById: action.payload,
        error: null,
      };

    case actionTypes.GET_ALL_CHARGE_TAX_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.GET_ALL_ADD_CHARGE_INVOICE_SUCCESS:
      return {
        ...state,
        getAllSubmit: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_ADD_CHARGE_INVOICE_FAIL:
      return {
        ...state,
        getAllSubmit: [],
        error: action.payload,
      };

    case actionTypes.GET_SUBMIT_ALL_ADD_CHARGE_INVOICE:   
      return {
        ...state,
        loading: true
      }  

    case actionTypes.GET_SUBMIT_ALL_ADD_CHARGE_INVOICE_SUCCESS: 
      return {
        ...state,
        getSubmitAll: action.payload,
        loading: false,
        error: null,
      };
    case actionTypes.GET_SUBMIT_ALL_ADD_CHARGE_INVOICE_FAIL:
      return {
        ...state,
        getSubmitAll: [],
        loading: false,
        error: action.payload
      };    

    case actionTypes.GET_INVOICE_NOT_BY_SUCCESS:
      return {
        ...state,
        getAllNot: action.payload,
        error: null,
      };
    case actionTypes.GET_INVOICE_NOT_BY_FAIL:
      return {
        ...state,
        getAllNot: [],
        error: action.payload,
      };
    case actionTypes.API_STATUS_SELLER:
      return {
        ...state,
        ApiStatusSeller: action.payload.data,
      };
    case actionTypes.GET_SELLER_INVOICE_EXPORT_SUCCESS:
      // Export success, you could store the result if needed
      return {
        ...state,
        downloading: false,
        exportData: action.payload, // Export data (PDF/Excel file info)
      };
    case actionTypes.GET_SELLER_INVOICE_EXPORT_FAIL:
      return {
        ...state,
        exportData: [],
        downloading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default getSellerTaxGenReducer;
